import React from 'react';
import LoadingSpinner from '../util/LoadingSpinner';
import ValidatedInput from '../util/ValidatedInput';
import CurrencyFormatInput from '../util/CurrencyFormatInput';
import FadeOutErrorMessage from '../util/FadeOutErrorMessage';
import { formatCurrency, stripCurrencyFormat } from '../../../lib/utils';
import { CurrencyTypes } from '../../../lib/systemVariables';

const initialState = {
    updatedAmount: null,
    updateAttempted: false,
    updateError: false
};

export default class UpdateApplicationAmtInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = initialState;
    }

    updateAmount(name, value) {
        this.setState({
            updatedAmount: parseFloat(value || 0) !== parseFloat(this.props.maxAmount || 0)
                ? value : null
        });
    }

    async saveUpdate() {
        this.setState({ updateAttempted: true, updateError: false });

        if (this.state.updatedAmount > this.props.maxAmount)
            return;

        await this.props.update(this.props.application, { amount: this.state.updatedAmount });
        if (this.props.updateError) {
            this.setState({ updateError: true });
        } else {
            this.setState({ updatedAmount: null });
        }
    }

    cancelUpdate() {
        this.setState(initialState);
    }


    render() {
        const { amount, currency} = this.props.application;
        return (
            <div className="dollar-input-container dollar-input-container--inline-actions">
                <ValidatedInput input={<CurrencyFormatInput className="input" isIsraeli={currency === CurrencyTypes.Shekel}/>}
                    value={this.state.updatedAmount !== null ? this.state.updatedAmount : (amount || '')}
                    onChange={this.updateAmount.bind(this)} onKeyDown={e => { if (e.key === 'Enter' && this.state.updatedAmount !== null) this.saveUpdate() }}
                    validated={true} showValidationError={this.state.updateAttempted}
                    validate={val => !val || stripCurrencyFormat(val) <= this.props.maxAmount}
                    errorMessage={`Application amount cannot exceed ${formatCurrency(this.props.maxAmount, currency === CurrencyTypes.Shekel)}.`} />
                <div className="dollar-input-edit">
                    {this.props.updating
                        ? <LoadingSpinner height="12" />
                        : (this.state.updatedAmount !== null && <div>
                            <i className="material-icons input" onClick={this.saveUpdate.bind(this)}>check</i>
                            <i className="material-icons input" onClick={this.cancelUpdate.bind(this)}>close</i>
                        </div>)}
                </div>
                <FadeOutErrorMessage show={this.state.updateError} />
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/UpdateApplicationAmtInput.jsx